import auth from './auth';
import form from './form';
import debugLog from './debugLog';

import {createStore} from 'vuex';
 
const store = createStore({
    modules:{
        auth: auth,
        form: form,
        debugLog: debugLog,
    }
});
 
export default store;